module.exports = __webpack_public_path__ + "img/100-image-1.e0eaf0c3.png";